import { defineComponent as _defineComponent } from 'vue'
type Emits = {
    (e: "clickedClose"): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'close',
  emits: ["clickedClose"],
  setup(__props, { expose, emit }: { emit: ({
    (e: "clickedClose"): void,
}), expose: any, slots: any, attrs: any }) {
  expose();



const emitCloseClicked = () =>{
    emit('clickedClose')
}


const __returned__ = { emit, emitCloseClicked }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})